import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class ValidationService {
  constructor(
    public translate: TranslateService
  ){

  }

    getValidatorErrorMessage(validatorName: string, validatorValue?: any): any {
        const config = {
            'required': 'Required',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email',
            // 'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'invalidPassword': 'must be at least 8 characters long, contain number and letter.',
            'invalidPin': 'must be 6 characters long, number only.',
            'minlength': `Minimum length ${validatorValue.requiredLength}`,
            // 'pattern': `Invalid input pattern`,
            'newInvalidPassword': ' contain number, symbol and letter.',
            'pattern': 'Must contain numbers, lowercase & uppercase letters, and symbol'
        };

        return this.translate.instant(config[validatorName]);
    }

    static creditCardValidator(control): any {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value) {
            if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
                return null;
            } else {
                return { 'invalidCreditCard': true };
            }
        }
    }

    static emailValidator(control): any {
        // RFC 2822 compliant regex
        if (control.value) {
            if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
                return null;
            } else {
                return { 'invalidEmailAddress': true };
            }
        }
    }

    static passwordValidator(control): any {
        // {8,50}           - Assert password is between 8 and 50 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        // ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}
        if (control.value) {
            //if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            if (control.value.match(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]{8,50}$/)) { // add by ari
                return null;
            } else {
                return { 'invalidPassword': true };
            }
        }
    }

    static pinValidator(control): any {
        // {6}           - Assert password is between 8 and 50 characters
        // ([0-9])       - Assert numeric only
        if (control.value) {
            if (control.value.match(/[0-9]{6}/)) { // add by dhanu
                return null;
            } else {
                return { 'invalidPin': true };
            }
        }
    }

    static newPasswordValidator(control): any {
        // {8,50}           - Assert password is between 8 and 50 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        // ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}
        if (control.value) {
            //if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            if (control.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/)) { // add by ari
                return null;
            } else {
                return { 'newInvalidPassword': true };
            }
        }
    }

    static noPasswordValidator(control): any {
        // {8,50}           - Assert password is between 8 and 50 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        // ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}
        if (control.value) {
            //if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        }
    }

    static changePasswordValidator(control): any {
        if (control.value) {
            if (control.value.match(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,50}$/)) {
                return null;
            } else {
                return { 'invalidChangePassword': true };
            }
        }
    }

}




// WEBPACK FOOTER //
// ./src/providers/validation.service.ts